import { Event } from './Event'

export class Report {
  id: number;
  title: string;
  created: Date;
  edited: Date;
  author: string;
  content: string;
  event: Event;
}
